<template>
  <template v-if="tag">
    <!-- Renders with the tag if it's provided -->
    <component
      :style="{ color: color }"
      :is="tag"
      :class="[`body-${bodyType} font-weight-${weight}`, className]"
      @click="$emit('click')"
    >
      {{ translatedText }}
    </component>
  </template>
  <template v-else>
    <!-- Renders just the content if no tag is provided -->
    {{ translatedText }}
  </template>
</template>

<script>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { includesValidator } from '~/utils/validator';

const weightTypes = ['regular', 'medium'];

const bodyTypes = [1, 'ui-1', 2, 3, 4, 5];
export default {
  name: 'TextBody',
  emits: ['click'],
  props: {
    bodyType: {
      type: [Number, String],
      default: 1,
      validator: includesValidator(bodyTypes),
    },
    weight: {
      type: String,
      default: 'regular',
      validator: includesValidator(weightTypes),
    }, // path of the string in i18n dictionary
    keyPath: {
      default: '',
      type: String,
    }, // custom values given as params to the messsage in dictionary
    values: {
      default: () => [],
      type: Array,
    }, // custom tag to render text
    tag: {
      default: '',
      type: String,
    }, // only need this until we can compute translateText
    text: {
      default: '',
      type: String,
    },
    color: {
      default: '#1c1c1dcc',
      type: String,
    },
    i18nKey: {
      default: '',
      type: String,
    },
    i18nParams: {
      default: () => {},
      type: Object,
    },
    className: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { t } = useI18n();

    const translatedText = computed(() => (props.i18nKey ? t(props.i18nKey, props.i18nParams) : props.text));

    return {
      translatedText,
    };
  },
};
</script>

<style scoped lang="scss">
.body-1 {
  @include bb-base-font-family;
  @include bb-regular-text-styles('md');
}

.body-ui-1 {
  size: 15px;
  line-height: 16px;
}

.body-2 {
  @include bb-regular-text-styles('lg');
}

.body-3 {
  @include bb-regular-text-styles('sm');
}

.body-4 {
  size: 11px;
  line-height: 16px;
}

.body-5 {
  @include bb-regular-text-styles('xs');
}

.font-weight-regular {
  font-weight: 400;
}

.font-weight-medium {
  font-weight: 500;
}

.ellipsis-1-row {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.ellipsis-2-rows {
  overflow: hidden;
  //text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
